<div class="variant-snackbar">
    <div class="variant-snackbar-container">
        <div class="message">Image has been removed</div>
        <div (click)="undoDeleteImage()" class="variant-undo">Undo</div>
        <mat-icon
            class="variant-snackbar-close"
            (click)="closeDeleteAlertSnackBar()"
            >close</mat-icon>
    </div>
</div>
